import { CCol, CRow, CLabel, CTextarea } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall, apiCallResponse } from "src/_apiConfig/apiCall";

import { TableHeader } from "../common/Table/TableHeaderLabel";
import Auth from "src/auth";
import {
  FilterEqual,
  FilterContainsInsensitive,
  FilterKeyWord,
} from "../common/FilterCondition";
import {
  CommonSearch,
  SCSelect,
  updateSearchStatus,
} from "../common/CommonSearch";
import ConfirmationPopup from "../common/ConfirmationPopup";
import CommonList from "../common/CommonList";
import TableDateTimeFromat from "../common/Table/TableDateTimeFromat";
import CustomeModalPopup from "../common/CustomeModalPopup";
import TableButtonClick from "../common/Table/TableButtonClick";

const IncomeTaxRequestList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [textField, settextField] = useState("lotNo");

  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [rejectionReason, setRejectionReason] = useState();
  const [selectedLotPaymentId, setSelectedLotPaymentId] = useState();
  const [rejectionWindowOpen, setRejectionWindowOpen] = useState(false);
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage

  const [ButtonLoader, SetButtonLodaer] = useState(false); // adding button loader
  // Your default search model
  const SearchFilterModel = {
    collectionSeason: new Date().getFullYear().toString(),
    tenderNo: "",
    companyName: "",
    emailAddress: "",
    lotNo: "",
    installmentNo: "",
    status: "Pending",
  };

  const [search, setSearch] = useState(SearchFilterModel);
  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);
  //-------------------------------------------------------
  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
  };
  const SubmitConfirmationPopUpResponse = async () => {
    handleRejectionWindowClose();
    ApproveApiCall(CPopUpId);
  };

  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getBidderList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getBidderList(true);
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const handleDownloadTaxConsessionDocument = async (lotid, lotPaymentId) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadTaxConsessionDocument?lotid=${Number(
        lotid
      )}&lotpaymentid=${Number(lotPaymentId)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    jsonobj.blob().then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = lotid + "_" + lotPaymentId + ".pdf";
      alink.click();
    });
  };

  const handlePopupOpen = (lotpaymentid) => {
    setSelectedLotPaymentId(lotpaymentid);
    setRejectionWindowOpen(true);
  };
  const handleRejectionWindowClose = () => setRejectionWindowOpen(false);

  const RejectApiCall = async (e) => {
    e.preventDefault();
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "LotDetails/RejectTaxConsessionRequest",
      "POST",
      header,
      JSON.stringify({
        Id: Number(selectedLotPaymentId),
        TaxConsessionRejectionReason: rejectionReason,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("Tax Concession Request rejected successfully.");
      //window.location.reload();
      setRejectionReason();
      handleRejectionWindowClose();
      getBidderList(true);
    } else {
      alert("Error in Rejection");
    }
    setloading(false);
  };
  const ApproveApiCall = async (id) => {
    SetButtonLodaer(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "LotDetails/AproveTaxConsessionRequest",
      "POST",
      header,
      JSON.stringify({
        Id: id,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("Tax Consession Request approved successfully");
      handleConfirmationPopUpModalClose();
      getBidderList(true);
    } else {
      alert("Error in approval");
    }
    SetButtonLodaer(false);
    setloading(false);
  };

  const reset = () => {
    setpageLimit(0);
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `LotDetails/GetLotDetailsForIncomeTaxApproval?${filterManage()}`
      ).then((res) => {
        if (res.success) paggingDisabledManage(parseInt(res.data.length) || 0);
      });
    }
  };
  const getBidderList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `LotDetails/GetLotDetailsForIncomeTaxApproval?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${parseInt(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setuserData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
  };

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";

    filter = FilterEqual(filter, "collectionSeason", search.collectionSeason);
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);
    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);

    if (search.installmentNo !== "" && search.installmentNo !== undefined) {
      if (search.installmentNo === "-2" || search.installmentNo === "-6") {
        filter = FilterKeyWord(
          filter,
          "tenderPaymentSlotsId",
          parseInt(search.installmentNo),
          "eq"
        );
      } else {
        filter = FilterEqual(
          filter,
          "tenderPaymentComplete",
          search.installmentNo
        );
      }
    }
    filter = FilterEqual(filter, "requestStatus", search.status);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };

  //table header Click manage
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };

  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    setpageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    setpageLimit(pageLimitSet);
  };

  const scopedSlotsList = {
    incomeTaxConsessionRequestDateFormate: (item, index) => {
      return TableDateTimeFromat(item.incomeTaxConsessionRequestDate);
    },
    DownloadConsessionDocument: (item, index) => {
      return (
        <TableButtonClick
          buttonName={"Download"}
          isDisplayAllow={
            item.incomeTaxConsessionDocument === "" &&
            item.incomeTaxConsessionDocument === null
              ? false
              : true
          }
          onClick={() =>
            handleDownloadTaxConsessionDocument(item.lotId, item.id)
          }
        />
      );
    },
    displayInstallment: (item, index) => {
      return (
        <td className="py-2">
          <span>{getPaymentDescription(item)}</span>
        </td>
      );
    },
    ApproveTaxConsessionRequest: (item, index) => {
      return (
        <TableButtonClick
          buttonName={"Approve"}
          isDisplayAllow={item.requestStatus === "Pending"}
          onClick={() =>
            ConfirmationPopupHandler(
              item.id,
              -1,
              "Are you sure you want to Approve?"
            )
          }
        />
      );
    },
    RejectTaxConsessionRequest: (item, index) => {
      return (
        <>
          <TableButtonClick
            isDisplayAllow={item.requestStatus === "Pending"}
            color={"danger"}
            buttonName={"Reject"}
            onClick={() => handlePopupOpen(item.id)}
          />
        </>
      );
    },
  };
  const fields = [
    {
      key: "lotNo",
      _style: { width: "10%" },
      label: TableHeaderSet("Lot No", "lotNo"),
    },
    {
      key: "tenderNo",
      label: TableHeaderSet("Tender No", "tenderNo"),
      _style: { width: "7.5%" },
    },
    {
      key:"bidderName",
      label: TableHeaderSet("Bidder Name", "bidderName"),
      _style: { width: "7.5%" },
    },
    
       {
      key: "companyName",
      label: TableHeaderSet("Company Name", "companyName"),
      _style: { width: "7.5%" },
    },
    {
      key: "amount",
      label: TableHeaderSet("Payment Amount", "amount"),
      _style: { width: "7.5%" },
    },
    {
      key: "incomeTaxAmount",
      label: TableHeaderSet("Income Tax Amount", "incomeTaxAmount"),
      _style: { width: "7.5%" },
    },

    {
      key: "displayInstallment",
      label: <div>Request Type</div>,
      sorter: false,
      filter: false,
      _style: { width: "15%" },
    },
    {
      key: "requestStatus",
      label: <div>Status</div>,
      sorter: false,
      filter: false,
    },
    {
      key: "incomeTaxConsessionPercentage",
      label: TableHeaderSet(
        "IncomeTax Consession Percentage",
        "incomeTaxConsessionPercentage"
      ),
      _style: { width: "12.5%" },
    },
    {
      key: "incomeTaxConsessionRequestDateFormate",
      label: TableHeaderSet("Request Date", "incomeTaxConsessionRequestDate"),
      _style: { width: "15%" },
    },

    {
      key: "taxConsessionRejectionReason",
      label: <div>Reason for Rejection</div>,
      _style: { width: "15%" },
      sorter: false,
      filter: false,
    },
    {
      key: "DownloadConsessionDocument",
      label: <div>Download</div>,

      sorter: false,
      filter: false,
    },
    {
      key: "ApproveTaxConsessionRequest",
      label: <div>Approve</div>,
      sorter: false,
      filter: false,
    },
    {
      key: "RejectTaxConsessionRequest",
      label: <div>Reject</div>,
      sorter: false,
      filter: false,
    },
  ];

  const getPaymentDescription = (item) => {
    if (item.tenderPaymentComplete !== null) {
      switch (item.tenderPaymentComplete) {
        case "25":
          return "First Installment";
        case "50":
          return "Second Installment";
        case "75":
          return "Third Installment";
        case "100":
          return "Fourth Installment";
        default:
          return "Other";
      }
    } else if (parseInt(item.tenderPaymentSlotsId) === -6) {
      return "Godown Quantity Diff Payment";
    } else if (parseInt(item.tenderPaymentSlotsId) === -2) {
      return "Full Payment";
    } else {
      return "Other";
    }
  };
  const installmentNoList = [
    { value: "25", label: "First Installment" },

    { value: "50", label: "Second Installment" },
    { value: "75", label: "Third Installment" },
    { value: "100", label: "Fourth Installment" },
    { value: "-2", label: "Full Payment" },
    { value: "-6", label: "Godown Quantity Diff Amount" },
  ];

  const statusList = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  const SearchExtraControl = (
    <>
      <SCSelect
        labelname="Request Type"
        name="installmentNo"
        value={search.installmentNo}
        onChange={updateSearch}
        items={installmentNoList}
      />

      <SCSelect
        labelname="Status"
        name="status"
        value={search.status}
        onChange={updateSearch}
        items={statusList}
      />
    </>
  );
  const additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      //isEmailAddressDisplay={true}
      extraControl={SearchExtraControl}
      isLotNumberDisplay={true}
    />
  );
  return (
    <>
      <CommonList
        items={usersData}
        fields={fields}
        listName="Income Tax Concession Request"
        loading={loading}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        additional={additional}
        id="id"
        scopedSlots={scopedSlotsList}
      />
      <ConfirmationPopup
        showModal={CPopUpDisplayConfirmationModal}
        hideModal={handleConfirmationPopUpModalClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={CPopUpId}
        index={CPopUpIndex}
        ModalBody={CPopUpBodyText}
        // ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        ButtonLoader={ButtonLoader}
      />
      <CustomeModalPopup
        onOpen={rejectionWindowOpen}
        onClose={handleRejectionWindowClose}
        onSubmitButton={RejectApiCall}
        onCloseButton={handleRejectionWindowClose}
        isSubmitBtnDisabled={false}
        isFromSubmit={true}
        popupWith={450}
        body={
          <CRow>
            <CCol>
              <CLabel> Reason for Rejection:</CLabel>
              <CTextarea
                onChange={(e) => setRejectionReason(e.target.value)}
                required
              />
            </CCol>
          </CRow>
        }
      />
    </>
  );
};

export default IncomeTaxRequestList;
